import React from "react";

import AdvisorContainer from "../AdvisorContainer";
import AdvisorContentContainer from "../AdvisorContentContainer";
import FinOpsLayout from "@src/multiCustodian/components/Advisor/FinanicalOperations/FinOpsLayout";
import ProposalBundlesTable from "@src/multiCustodian/components/Advisor/FinanicalOperations/ProposalBundles/ProposalBundlesTable";

const TradeProposalBundles: React.FC = () => {
  return (
    <AdvisorContainer>
      <AdvisorContentContainer heroTitle={"Financial Operations"}>
        <FinOpsLayout>
          <ProposalBundlesTable />
        </FinOpsLayout>
      </AdvisorContentContainer>
    </AdvisorContainer>
  );
};

export default TradeProposalBundles;
